import Keycloak from 'keycloak-js';

import BaseConstants from '../constants/BaseConstants';

const keycloakConfig = {
    url: BaseConstants.KEYCLOAK_SERVER,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID
};

export const keycloak = new Keycloak(keycloakConfig);

export const initConfig = {
    onLoad: 'login-required',
    checkLoginIframe: false,
    enableLogging: process.env.NODE_ENV === 'development',
    pkceMethod: 'S256',
    flow: 'standard',
    responseMode: 'fragment',
    tokenStore: 'sessionStorage',
    iframe: {
        check: false
    }
};

keycloak.onAuthSuccess = () => {
    console.log('Auth Success');
};

keycloak.onAuthError = (error) => {
    console.error('Auth Error Details:', {
        error,
        state: keycloak.authenticated,
        token: keycloak.token,
        timeSkew: keycloak.timeSkew
    });

    // Try to recover from the error
    try {
        keycloak.clearToken();
    } catch (e) {
        console.error('Error clearing token:', e);
    }
};

keycloak.onReady = (authenticated) => {
    console.log('Keycloak Ready Status:', {
        authenticated,
        initialized: keycloak.initialized,
        token: !!keycloak.token
    });
};

keycloak.onTokenExpired = () => {
    console.log('Token expired, attempting refresh...');
    keycloak.updateToken(30).then((refreshed) => {
        if (refreshed) {
            console.log('Token was successfully refreshed');
        } else {
            console.log('Token is still valid');
        }
    }).catch(error => {
        console.error('Failed to refresh token:', error);
    });
}; 